import type {ValueOf} from '@myparcel-frontend/types';
import {TierName} from '@/types/subscriptions/tiers';

export const BundlesProductId = {
  Start: 4800,
  Plus: 4801,
  Premium: 4802,
  Max: 4803,
} as const;

export const BundlesTierName = {
  Start: TierName.Start,
  Plus: TierName.Plus,
  Premium: TierName.Premium,
  Max: TierName.Max,
} as const;

export const BUNDLES_IDS_TO_NAMES = {
  [BundlesProductId.Start]: BundlesTierName.Start,
  [BundlesProductId.Plus]: BundlesTierName.Plus,
  [BundlesProductId.Premium]: BundlesTierName.Premium,
  [BundlesProductId.Max]: BundlesTierName.Max,
} as const;

export const toBundlesTierName = <T extends ValueOf<typeof BundlesProductId>>(id: T) => {
  return BUNDLES_IDS_TO_NAMES[id];
};

